













































































































import {Component, Ref, Vue} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import {Collapse, DatePickerWings, InputWings, SelectWings, SpoilerWings, ToggleWings,} from "wings-ui-components";
import {CollapseTransition} from "vue2-transitions";
import {cloneDeep, isEqual} from "lodash";
import {notifyConfirm, notifyDelete, notifyError,} from "@/utils/notify-helper";
import {PartnerItem} from "@/store/settings/partners/types";
import {
  ChangePartnerUserRole,
  PageBlocks,
  PartnerUserRolesItem,
} from "@/store/user_management/partner_user_roles/types";
import i18n from "@/plugins/i18n";
import Swal from "sweetalert2";
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

Component.registerHooks(["beforeRouteLeave"]);

@Component({
  components: {
    SelectWings,
    DatePickerWings,
    ToggleWings,
    Collapse,
    SpoilerWings,
    CollapseTransition,
    InputWings
  },
})
export default class PartnerUserRole extends Vue {
  @Action("getPartnerUserRoleItem") actionGetItem: any;
  @Action("getPartnerUserPageBlocks") actionGetPages: any;
  @Action("savePartnerUserRole") actionSave: any;
  @Action("deletePartnerUserRole") actionDelete: any;
  @Action("getPartnerUserRoles") actionGetPartnerUserRoles: any;
  @Action("changePartnerUserRole") actionChangePartnerRole: any;
  @Action("actionLog") actionLog: any;

  @Getter("partnerUserRoles") userRolesResponse: any;

  @Ref("validator") validator: any;

  @Getter("pageBlocks") pageBlocksList: any;

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  private logObject: ActionLog = {}

  defaultItem(): PartnerUserRolesItem {
    return {
      name: "",
      ad_group_name: "",
      partner_user_page_blocks: [],
    };
  }

  get pages() {
    return (
        this.item.partner_user_page_blocks?.filter(
            (e: any) => e.id !== 1 && e.id !== 2
        ) ?? []
    );
  }

  async created() {
   this.actionGetPartnerUserRoles();
   await this.actionGetPages();
    if (this.$route.params.id) {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Personal account role",
        object_name: this.item.name,
        addititional_info: getTranslatedParams({id: this.$route.params.id})
      }
      this.actionGetItem(this.$route.params.id).then((data: PartnerItem) => {
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
        this.actionLog(this.logObject);
      }).catch(()=>{
        this.actionLog({...this.logObject, action_status: "failed"});
      });
    } else {
      this.pageBlocksList.map((page:PageBlocks)=> {
        this.item.partner_user_page_blocks?.push(page);
      });
    }
  }

  back(): void {
    this.$router.push("/user_management/partner_user_roles/");
  }

  onSaveItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid: boolean = await this.validator.validate();
      if (valid) {
        try {
          const data = cloneDeep(Object.assign({}, this.item));
          data?.partner_user_page_blocks?.filter((value)=>{
            delete value.rus_name
            delete value.eng_name
            if (value.id === 1 || value.id === 2){
              value.allowed = 1;
            }else if (!value.allowed){
              value.allowed = 0;
            }
          })
          await this.actionSave(data);
          await this.logChangeName('success');
          await this.logChangeRole('success');
          this.itemSaved = this.item;
          resolve();
          this.back();
        } catch (error) {
          await this.logChangeName('failed');
          await this.logChangeRole('failed');
          reject();
          notifyError(error);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors);
        }, 100);
      }
    });
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Personal account role",
          object_name: this.item.name,
          addititional_info: getTranslatedParams({id: this.$route.params.id})
        }
        await this.actionDelete(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});

        if (error?.response?.data?.code == '36'){
          const swalAlert: any = Swal.mixin({
            customClass: {
              input: 'alert-select-style',
            },
          })

          const newRole = await swalAlert.fire({
            input: 'select',
            inputOptions: this.getNotIncludedUserRoles(),
            type: "warning",
            inputPlaceholder: i18n.tc('choose_role'),
            title: i18n.tc('dialog.warning'),
            html: i18n.tc('errors.have_users_with_this_role'),
            showCancelButton: true,
            confirmButtonClass: "md-button md-primary",
            cancelButtonClass: "md-button",
            confirmButtonText: i18n.tc('remove'),
            cancelButtonText: i18n.tc('cancel'),
            buttonsStyling: false,
        });
        let changeUserRole: ChangePartnerUserRole = {
          old_role_id: this.$route.params.id,
          new_role_id: {
            role_id: this.getRoleIdByName(newRole.value)
          }
        }
        const logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Access rights modification",
          action_status: "success",
          object_type: "Personal account",
          object_name: this.item.name,
          addititional_info: getTranslatedParams({
            old_role_id: this.getCurrentUserRoleName(this.$route.params.id),
            new_role_id: newRole.value
          })
        }
        this.actionChangePartnerRole(changeUserRole).then(()=>{
          this.actionDelete(this.item);
          if (newRole?.value){
            this.actionLog(logObject);
          }
          this.back();
        });
        } else {
          notifyError(error);
        }
      }
    }
  }

  async logChangeName (action_status: string) {
    if (isEqual(this.item.name, this.itemSaved.name)) return;
    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: this.$route.params.id ? "Editing" : "Creation",
      action_status: action_status,
      object_type: "Personal account role",
      object_name: this.item.name,
      addititional_info: getTranslatedParams({id: this.$route.params.id})
    }
    await this.actionLog(this.logObject);
  }

  async logChangeRole (action_status: string) {
    if (!this.$route.params.id) return;
    const fieldsToCompare: Array<keyof PartnerUserRolesItem> = ['partner_user_page_blocks', 'ad_group_name'];
    const isEqualAll = fieldsToCompare.every(field => isEqual(this.item[field], this.itemSaved[field]));
    if (isEqualAll) return;

    const sections = this.pages?.reduce((acc: any, item) => {
      const key = this.pageBlocksList.find((e: any) => e.id === item.id);
      const value = item.allowed ? 'Доступен/Available' : 'Недоступен/Not available';
      acc[`${key.eng_name}/${key.rus_name}`] = value;
      return acc;
    }, {});

    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: "Access rights modification",
      action_status: action_status,
      object_type: "Personal account role",
      object_name: this.item.name,
      addititional_info: {'Разделы/Sections': sections, ...getTranslatedParams({ad_group_name: this.item.ad_group_name})}
    }

    await this.actionLog(this.logObject);
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  getNamePageByLang(id: number): string | undefined {
    if (this.$i18n.locale === "ru") {
      return this.pageBlocksList.find((e: any) => e.id === id)?.rus_name;
    } else {
      return this.pageBlocksList.find((e: any) => e.id === id)?.eng_name;
    }
  }

  getNotIncludedUserRoles(){
    let roles = new Map();
    this.userRolesResponse.forEach((e: any) => {
      if (e.id != this.$route.params.id){
        roles.set(e.name, e.name);
      }
    })
    return roles;
  }

  getCurrentUserRoleName(id: string){
    const foundRole = this.userRolesResponse.find((item: any) => item.id == id);
    return foundRole ? foundRole.name : null;
  }

  getRoleIdByName(name: string): number {
    return this.userRolesResponse.filter((e: any) => e.name === name)[0]?.id
  }
}
